import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Producto } from '@shared/models/abm/Producto';
import { StockService } from '../../stock.service';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from '@account/usuario.service';
import { ModalTransfenrenciaComponent } from './modal-transfenrencia/modal-transfenrencia.component';
import { UntypedFormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ProductoService } from '@abm/producto/producto.service';
import { Transaccion } from '@shared/models/stock/Transaccion';
import { Contenedor } from '@shared/models/stock/Contenedor';
import { TipoMovimientoStock } from '@shared/enums/tipoMovimientoStock';
import { TransaccionesService } from '../../transacciones.service';
import { IngresoDuctoComponent } from '../../listados/ingreso-ducto/ingreso-ducto.component';
import { IngresoDucto } from '@shared/models/stock/IngresoDucto';
import { MessageService } from '@shell/message.service';
import { EmisionRemitoComponent } from '../../listados/emision-remito/emision-remito.component';
import { AjusteManualCombustibleComponent } from '../../listados/ajuste-manual-combustible/ajuste-manual-combustible.component';
import { AjusteManualAeroespecialidadesComponent } from '../../listados/ajuste-manual-aeroespecialidades/ajuste-manual-aeroespecialidades.component';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { SharedService } from '@shared/shared.service';
import { MovimientoDetalleComponent } from '../movimiento-detalle/movimiento-detalle.component';
import { ModalRecepcionCombustibleComponent } from '@stock/recepcion-contingencia/modal-recepcion-combustible/modal-recepcion-combustible.component';
import { TanqueService } from '@stock/tanques.service';
import { Tanque } from '@shared/models/stock/Tanque';
import { DatePipe } from '@angular/common';
import { filtrosReporteMovimientosDTO } from "@shared/models/stock/FiltrosReporteMovimientosDTO";
import { ModalExportarMovimientosComponent } from './modal-exportar-movimientos/modal-exportar-movimientos.component';
import { TipoTransaccion } from "@shared/enums/TipoTransaccion";

@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.css']
})
export class MovimientosComponent implements OnInit, OnDestroy {
  productos: Producto[] = [];
  obteniendoMovimientos = true;
  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  fechaDesde: Date;
  fechaHasta: Date;
  fechaDesdeExportar: Date;
  fechaHastaExportar: Date;
  contenedores: Contenedor[];
  transaccion: Transaccion[] = [];
  transaccionesFiltrados: Transaccion[];
  productosParaCheckear: any[] = [];
  contenedoresParaCheckear: any[] = [];
  fechaFormControlDesdeHasta = new UntypedFormControl();
  errorMovimientos = false;
  reporteMovimientos: filtrosReporteMovimientosDTO = new filtrosReporteMovimientosDTO();
  change$: Subscription;
  transaccionSeleccionada: Transaccion;
  tipoMovimientos: any[] = [
    { "nombre": 'Despacho', "codigo": 0, "seleccionado": false },
    { "nombre": 'Ajuste Manual', "codigo": 2, "seleccionado": false },
    { "nombre": 'Transferencia', "codigo": 3, "seleccionado": false },
    { "nombre": 'Rebombeo', "codigo": 4, "seleccionado": false },
    { "nombre": 'Alije', "codigo": 5, "seleccionado": false },
    { "nombre": 'Recepción', "codigo": 6, "seleccionado": false },
    { "nombre": 'Salida', "codigo": 8, "seleccionado": false },
    { "nombre": 'Ajuste Automatico', "codigo": 9, "seleccionado": false },
    { "nombre": 'Recarga', "codigo": 10, "seleccionado": false }
  ];

  TipoUsuario = TipoUsuario;
  combustiblesSeleccionadosRecepcion: boolean;
  cargandoModalRecepcion: boolean;
  tanquesRecepcion: Tanque[];

  goBack$: Subscription;

  constructor(private authService: AuthService,
    private messageService: MessageService,
    private stockService: StockService,
    private calendar: NgbCalendar,
    private usuarioService: UsuarioService,
    private datepickerConfig: NgbDatepickerConfig,
    private spinner: NgxSpinnerService,
    @Inject(LOCALE_ID) public locale: string,
    private modalService: NgbModal,
    private productoService: ProductoService,
    private transaccionesService: TransaccionesService,
    private datePipe: DatePipe,
    private tanquesService: TanqueService,
    sharedService: SharedService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.recargarPagina()
      })
      this.goBack$ = stockService.goBack.subscribe((estado) => {
        console.log("escuchando: ", estado);
        this.combustiblesSeleccionadosRecepcion = estado;
        this.recargarPagina();
      })
    }

  // hooks

  ngOnInit() {
    this.transaccionesFiltrados = [];
    this.transaccion = [];
    this.spinner.show('spinnerLista');
    this.errorMovimientos = false;
    this.getTodosLosProductos();
    this.cargarCheckTipoOrigen();
    this.modelDesde = this.calendar.getToday();
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.modelHasta = this.calendar.getToday();
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.reinicioFechaInicioFechaFin();

    this.datepickerConfig.minDate = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig.maxDate = { day: 31, month: 12, year: 2050 };
    this.getTodosLosMovimientos(this.usuarioService.getAeroplantaActual().codigoAeroplanta, this.fechaDesde, this.fechaHasta);
  }

  // form

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  cargarCheckTipoOrigen() {
    this.stockService.getTodosLosContenedores(this.usuarioService.getAeroplantaActual().codigoAeroplanta)
      .subscribe(result => {
        this.contenedoresParaCheckear = [];
        this.contenedores = result;
        for (const cont of this.contenedores) {
          this.contenedoresParaCheckear.push({ "nombre": cont.nombre, "codigo": cont.codigo, "seleccionado": false });
        }
      })
  }

  buscarDesdeHasta() {
    // guardar la ultima fecha desde-hasta consultada, y esta mandarla al modal de exportar_excel-component
    this.transaccion = [];
    this.transaccionesFiltrados = [];
    this.obteniendoMovimientos = true;
    this.reinicioFechaInicioFechaFin();
    return this.getTodosLosMovimientos(this.usuarioService.getAeroplantaActual().codigoAeroplanta, this.fechaDesde, this.fechaHasta);
  }

  nuevoIngresoDucto() {
    const modalRef = this.modalService.open(IngresoDuctoComponent, { centered: true, backdrop: 'static' });
    modalRef.result.then((result: IngresoDucto) => {
      if (result) {
        this.messageService.showSuccessMessage('Se realizo el ingreso por ducto correctamente.');
        this.recargarPagina();
      }

    });
  }

  nuevaRecepcionContingencia() {
    this.cargandoModalRecepcion = true;
    const productos = [];
    const productosCodigo = [];
    const aeroplanta = this.usuarioService.getAeroplantaActual();
    this.tanquesService.getTanquesPorAeroplanta(aeroplanta.codigoAeroplanta).subscribe(tanques => {
      const tanquesActivos = tanques.filter(t => t.activo);
      tanquesActivos.forEach(tanque => {
        if(!productosCodigo.includes(tanque.productoActual.codigoProducto)) {
          productos.push(tanque.productoActual);
          productosCodigo.push(tanque.productoActual.codigoProducto);
        }
      })
      const modalRef = this.modalService.open(ModalRecepcionCombustibleComponent, {centered: true, backdrop: 'static' });
      this.cargandoModalRecepcion = false;
      console.log(tanquesActivos);
      this.tanquesRecepcion = tanquesActivos;
      modalRef.componentInstance.productosLista = productos;
      modalRef.result.then((result) => {
        if(result){
          this.combustiblesSeleccionadosRecepcion = result;
        }
      })
    })
  }

  getTodosLosMovimientos(aeroplantaCod: string, fechaDesde: Date, fechaHasta: Date) {
    const desde: string = this.formatDate(fechaDesde.getFullYear(), fechaDesde.getMonth() + 1, fechaDesde.getDate(), 0, 0);
    const hasta: string = this.formatDate(fechaHasta.getFullYear(), fechaHasta.getMonth() + 1, fechaHasta.getDate(), 23, 59);
    this.fechaDesdeExportar = fechaDesde;
    this.fechaHastaExportar = fechaHasta;
    this.obteniendoMovimientos = true;
    this.spinner.show('spinnerLista');
    this.transaccionesService.getTransacciones(aeroplantaCod, desde, hasta)
      .subscribe(result => {
        this.transaccion = result.sort((a, b) => new Date(b.fechaHora).getTime() - new Date(a.fechaHora).getTime());
        this.transaccionesFiltrados = result.sort((a, b) => new Date(b.fechaHora).getTime() - new Date(a.fechaHora).getTime());
        this.filtrarMovimientos();
        this.obteniendoMovimientos = false;
        this.spinner.hide('spinnerLista');
      },
        () => {
          this.errorMovimientos = true;
          this.obteniendoMovimientos = false;
          this.spinner.hide('spinnerLista');
          this.transaccion = [];
          this.transaccionesFiltrados = [];
        }
      )

  }

  obtenerTipoMovimiento(tipo: number) {
    return TipoMovimientoStock[tipo];
  }

  getSomeMovimiento(tipoTransaccion: TipoTransaccion) {
    return this.transaccionesFiltrados.some(t => t.tipoTransaccion===tipoTransaccion);
  }

  filtrarMovimientos() {
    this.obteniendoMovimientos = true;
    this.transaccionesFiltrados = this.transaccion.filter(a => {
      let agregar = true;
      if (this.productosParaCheckear.some(b => b.seleccionado))
        agregar = agregar && this.productosParaCheckear.some(
          b => (b.seleccionado && true === this.obtenerFiltroPorProducto(a, b.codigo)));

      if (this.contenedoresParaCheckear.some(to => to.seleccionado))
        agregar = agregar && this.contenedoresParaCheckear.some(
          to => (to.seleccionado && a.nombresContenedores.includes(to.nombre)));

      if (this.tipoMovimientos.some(c => c.seleccionado))
        agregar = agregar && this.tipoMovimientos.some(
          c => (c.seleccionado && c.codigo === a.tipoTransaccion));

      return agregar;
    });
    this.obteniendoMovimientos = false;
  }

  obtenerFiltroPorProducto(a: Transaccion, t: string): boolean {
    let aux: boolean = false;
    for (let i = 0; a.productos.length > i; i++) {
      if (a.productos[i] != null) {
        if (a.productos[i].codigoProducto == t) {
          aux = true;
        }
      }
    }
    return aux
  }

  obtenerFiltroPorContenedor(a: Transaccion, t: string): boolean {
    let aux: boolean = false;
    for (let i = 0; a.nombresContenedores?.length > i; i++) {
        if (a.nombresContenedores[i] == t) {
          console.log("contenedor: " + a.nombresContenedores[i])
          aux = true;
        }
    }
    return aux
  }

  obtenerFiltroPorMovimiento(a: Transaccion, t: string): boolean {
    let aux: boolean = false;
    for (let i = 0; a.movimientos.length > i; i++) {
      if (a.movimientos[i].contenedor.codigo == t) {
        aux = true;
      }
    }
    return aux
  }

  reinicioFechaInicioFechaFin() {
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.fechaHasta.setHours(23, 59, 59, 99);
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    if (this.fechaDesde > this.fechaHasta) { esMayor = true; }
    return esMayor;
  }

  mayorAMes(fechaDesde: Date, fechaHasta: Date): boolean {
    const anioDesde = fechaDesde.getFullYear();
    const mesDesde = fechaDesde.getMonth();
    const diaDesde = fechaDesde.getDate();

    const anioHasta = fechaHasta.getFullYear();
    const mesHasta = fechaHasta.getMonth();
    const diaHasta = fechaHasta.getDate();

    const anioDiferencia = anioHasta - anioDesde;
    const mesDiferencia = mesHasta - mesDesde + anioDiferencia * 12;

    if (mesDiferencia > 1) return true;
    if (mesDiferencia === 1 && diaHasta > diaDesde) return true;

    return false;
  }

  recargarPagina() {
    this.productosParaCheckear = [];
    this.contenedoresParaCheckear = [];
    this.errorMovimientos = false;

    setTimeout(() => {
      this.spinner.show('spinnerLista');
    });

    this.obteniendoMovimientos = true;
    this.ngOnInit();
    this.limpiarCampos();
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
    this.goBack$.unsubscribe();
    this.transaccionesFiltrados = [];
    this.transaccion = [];
  }

  keysMovimientos(): Array<string> {
    let keys = Object.keys(this.tipoMovimientos);
    keys = keys.slice(keys.length / 2);
    return keys;
  }

  limpiarCampos() {
    this.transaccionesFiltrados = [];
    this.spinner.hide("spinnerLista");
    this.spinner.hide("spinnerDetalle");
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    // limpio filtro check tipo origen
    for (const tipo of this.contenedoresParaCheckear) {
      tipo.seleccionado = false;
    }
    for (const tipo3 of this.productosParaCheckear) {
      tipo3.seleccionado = false;
    }
  }

  mostrarDetalle(i: number) {
    const modalRef = this.modalService.open(MovimientoDetalleComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.transaccionSeleccionada = this.transaccionesFiltrados[i];
    modalRef.result.then((result: boolean) => {
      if (result) {
        this.recargarPagina();
      }
    });
  }

  descargarExcel(fechaDesde: Date, fechaHasta: Date){
      this.reporteMovimientos.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
      this.reporteMovimientos.fechaDesde = fechaDesde;
      this.reporteMovimientos.fechaHasta = fechaHasta;
      if (this.contenedoresParaCheckear.filter(contenedor => contenedor.seleccionado).length > 0) {
        this.reporteMovimientos.listaContenedores = this.contenedoresParaCheckear.filter(contenedor => contenedor.seleccionado).map(contenedor => contenedor.nombre);
      } else {
        this.reporteMovimientos.listaContenedores = [];
      }
      const modalRef = this.modalService.open(ModalExportarMovimientosComponent, { centered: true, backdrop: 'static', size: 'md' });
      modalRef.componentInstance.movimientos = this.reporteMovimientos;
      modalRef.componentInstance.fechaDesde = this.datePipe.transform(fechaDesde, 'dd/MM/yyyy');
      modalRef.componentInstance.fechaHasta = this.datePipe.transform(fechaHasta, 'dd/MM/yyyy');
      modalRef.componentInstance.enableExportRecepcion = this.getSomeMovimiento(TipoTransaccion.Recepcion);
      modalRef.componentInstance.enableExportRecarga = this.getSomeMovimiento(TipoTransaccion.Recarga);
  }

  nuevoIngresoTrasvase() {
    const modalRef = this.modalService.open(ModalTransfenrenciaComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.resultado.subscribe(result => {
      if (result == true) {
        this.recargarPagina();
      }
    });
  }

  emisionDeRemito() {
    const modalRef = this.modalService.open(EmisionRemitoComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.result.then((result: boolean) => {
      if (result) {
        this.messageService.showSuccessMessage('Se realizo el remito correctamente.');
        this.recargarPagina();
      }
    });
  }

  ajusteManualCombustible() {
    const modalRef = this.modalService.open(AjusteManualCombustibleComponent, { centered: true, backdrop: 'static' });
    modalRef.result.then((result: boolean) => {
      if (result) {
        this.messageService.showSuccessMessage('Se realizo el ajuste manual correctamente.');
        this.recargarPagina();
      }
    });
  }

  ajusteManualAeroespecialidad(){
    const modalRef = this.modalService.open(AjusteManualAeroespecialidadesComponent, { centered: true, backdrop: 'static' });
    modalRef.result.then((result: boolean) => {
      if (result) {
        this.recargarPagina();
      }
    });
  }
  // llamadas al service

  getTodosLosProductos() {
    this.productos = [];
    this.productoService.obtenerProductos()
      .subscribe(result => {
        this.productos = result;
        this.productosParaCheckear = [];
        for (const prod of this.productos) {
          this.productosParaCheckear.push({ "nombre": prod.nombreProducto, "codigo": prod.codigoProducto, "seleccionado": false });
        }
      });
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
